export enum ServiceAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_SERVICE_LIST = "ADD_SERVICE_LIST",
    UPDATE_SERVICE_LIST = "UPDATE_SERVICE_LIST",
    UPDATE_SERVICE_SEARCH_REQ = "UPDATE_SERVICE_SEARCH_REQ",
    SET_UPDATE_SERVICE = "SET_UPDATE_SERVICE",
}